function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const isReactNative = typeof navigator > "u" ? !1 : navigator.product === "ReactNative",
  defaultOptions = {
    timeout: isReactNative ? 6e4 : 12e4
  },
  processOptions = function (opts) {
    const options = _objectSpread(_objectSpread({}, defaultOptions), typeof opts == "string" ? {
      url: opts
    } : opts);
    if (options.timeout = normalizeTimeout(options.timeout), options.query) {
      const _splitUrl = splitUrl(options.url),
        url = _splitUrl.url,
        searchParams = _splitUrl.searchParams;
      for (const _ref of Object.entries(options.query)) {
        var _ref2 = _slicedToArray(_ref, 2);
        const key = _ref2[0];
        const value = _ref2[1];
        if (value !== void 0) if (Array.isArray(value)) for (const v of value) searchParams.append(key, v);else searchParams.append(key, value);
        const search = searchParams.toString();
        search && (options.url = `${url}?${search}`);
      }
    }
    return options.method = options.body && !options.method ? "POST" : (options.method || "GET").toUpperCase(), options;
  };
function splitUrl(url) {
  const qIndex = url.indexOf("?");
  if (qIndex === -1) return {
    url,
    searchParams: new URLSearchParams()
  };
  const base = url.slice(0, qIndex),
    qs = url.slice(qIndex + 1);
  if (!isReactNative) return {
    url: base,
    searchParams: new URLSearchParams(qs)
  };
  if (typeof decodeURIComponent != "function") throw new Error("Broken `URLSearchParams` implementation, and `decodeURIComponent` is not defined");
  const params = new URLSearchParams();
  for (const pair of qs.split("&")) {
    const _pair$split = pair.split("="),
      _pair$split2 = _slicedToArray(_pair$split, 2),
      key = _pair$split2[0],
      value = _pair$split2[1];
    key && params.append(decodeQueryParam(key), decodeQueryParam(value || ""));
  }
  return {
    url: base,
    searchParams: params
  };
}
function decodeQueryParam(value) {
  return decodeURIComponent(value.replace(/\+/g, " "));
}
function normalizeTimeout(time) {
  if (time === !1 || time === 0) return !1;
  if (time.connect || time.socket) return time;
  const delay = Number(time);
  return isNaN(delay) ? normalizeTimeout(defaultOptions.timeout) : {
    connect: delay,
    socket: delay
  };
}
const validUrl = /^https?:\/\//i,
  validateOptions = function (options) {
    if (!validUrl.test(options.url)) throw new Error(`"${options.url}" is not a valid URL`);
  };
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x;
}
export { getDefaultExportFromCjs, processOptions, validateOptions };